module.exports = __webpack_public_path__ + "static/revolutex-5d7912f1c46bc6d58819ddc714a47805.png";